import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { getTheme } from 'app/components/ThemeProvider/theme';
import { useMediaQuery } from '@mui/material';
import InfoIcon from 'app/components/Icons/InfoIcon';
import MenuEditIcon from 'app/components/Icons/MenuEditIcon';
import RepeatIcon from 'app/components/Icons/RepeatIcon';
import PrintIcon from 'app/components/Icons/PrintIcon';
import { useGetTransferDetails } from 'app/utils/services/transactionsService';
import logger from 'app/utils/logger';
import { LastOperationsType } from 'app/constants/types';

interface Props {
  menuButtons: any;
}
const useLastOperationsTable = (props: Props) => {
  const { menuButtons } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeAnchor, setActiveAnchor] = useState('');
  const [id, setId] = useState('');
  const [status, setStatus] = useState('');
  const [type, setType] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const theme = getTheme('light');
  const largeScreens = useMediaQuery(theme.breakpoints.down('lg'));
  const mediumScreens = useMediaQuery(theme.breakpoints.down('md'));

  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [asanConfirmation, setAsanConfirmation] = useState(false);
  const [snackbar, setSnackbar] = useState(false);

  const { signType } = useOutletContext<{ signType: any }>();

  const [details, setDetails] = useState([]);

  const {
    isSuccessGetTransferDetails,
    isLoadingGetTransferDetails,
    getTransferDetailsMutation,
    dataGetTransferDetails,
  } = useGetTransferDetails();

  useEffect(() => {
    logger.log('MENU', menuButtons);

    if (dataGetTransferDetails?.form_id === 'details_data') {
      setOpenDetailsModal(true);
      setAnchorEl(null);
    }

    if (dataGetTransferDetails?.form_id === 'asan_wait_popup') {
      setAsanConfirmation(true);
      setAnchorEl(null);
    }

    if (dataGetTransferDetails?.form_id === 'repayment') {
      navigate(`/az/transfer-page?type=${dataGetTransferDetails?.content_data.trn_type}`, {
        state: { templateData: dataGetTransferDetails?.content_data.data, formId: dataGetTransferDetails?.form_id },
      });
    }

    if (dataGetTransferDetails?.response === 'error') {
      setSnackbar(true);
    }

    if (dataGetTransferDetails?.print_forms !== undefined) {
      const files: any = document.getElementsByClassName('filesLastOperations');

      if (files !== null) {
        for (const file of files) {
          file.click();
        }
        setAnchorEl(null);
      }
    }
  }, [dataGetTransferDetails]);

  const handleClickMenu = (value: any) => {
    try {
      getTransferDetailsMutation({
        action: value,
        trn_id: id,
      });
    } catch (e) {
      logger.log(e);
    }
  };

  const handleMenuClick = (event: any, trnId: any, state: any, dbCr: any, trnButtons: string[]) => {
    const filteredMenuButtons: any = Object.fromEntries(
      Object.entries(menuButtons).filter(([key]) => trnButtons.includes(key))
    );

    setDetails(filteredMenuButtons);
    setId(trnId);
    setStatus(state);
    setType(dbCr);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setId('');
    setStatus('');
  };

  const handleMoveToTransfer = () => {
    navigate(`${lang}/transfer-page`);
  };

  useEffect(() => {
    if (anchorEl !== null) {
      setActiveAnchor(anchorEl.getAttribute('aria-controls'));
    }
  }, [anchorEl]);

  return {
    anchorEl,
    setAnchorEl,
    setActiveAnchor,
    handleMenuClick,
    handleClose,
    handleMoveToTransfer,
    activeAnchor,
    mediumScreens,
    details,
    handleClickMenu,
    openDetailsModal,
    setOpenDetailsModal,
    dataGetTransferDetails,
    asanConfirmation,
    setAsanConfirmation,
    status,
    isSuccessGetTransferDetails,
    isLoadingGetTransferDetails,
    signType,
    type,
    snackbar,
  };
};

export default useLastOperationsTable;
